import React, { useEffect, useState } from "react";
import styles from "./MyApplicationsPage.module.scss";
import ProjectsCardComponent from "../../components/ProjectsCardComponent/ProjectsCardComponent";
import { useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import { API } from "../../service/Interceptor";
import CustomSortDropdown from "../../components/CustomSortDropdown/CustomSortDropdown";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import ProjectCardSkeleton from "components/ProjectsCardComponent/ProjectCardSkeleton";
import noApplicationsImg from "../../images/errorImages/noApplications.png";
import InfiniteEndMessage from "components/InfiniteEndMessage/InfiniteEndMessage";

const sortOptions = ["Pending", "Shortlisted"];

const MyApplicationsPage = () => {
  // const dispatch = useDispatch();
  const location = useLocation();
  const page = location.pathname;

  const [searchApplication, setSearchApplication] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [myApplications, setMyApplications] = useState([]);
  const [selected, setSelected] = useState("Pending");
  const [isDeskstopView, setIsDeskstopView] = useState(
    !window.innerWidth > 1024
  );

  const getMyApplications = async (search = "", shortBy = "") => {
    try {
      setIsLoading(true);
      const query = new URLSearchParams();

      if (search) query.append("search", search);
      if (shortBy)
        query.append(
          "shortBy",
          shortBy === "Shortlisted" ? "SHORTLIST" : shortBy.toUpperCase()
        );

      const res = await API.get(`api/job-applications?${query.toString()}`);
      setMyApplications(res?.data?.data?.results || []);
    } catch (error) {
      console.log("Error fetching applications:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let debounceTimeout;

    if (searchApplication) {
      debounceTimeout = setTimeout(() => {
        getMyApplications(searchApplication, selected);
      }, 500);
    } else {
      getMyApplications(searchApplication, selected);
    }

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [searchApplication, selected]);

  useEffect(() => {
    const checkScreenSize = () => setIsDeskstopView(false);
    checkScreenSize(); // Run on mount
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section className={styles.my_applications_main}>
      <section className={styles.my_applications_top_details}>
        <div className={styles.my_applications_details}>
          <p className={styles.my_applicationstop_title}>
            My Applications ({myApplications?.length})
          </p>
          <p className={styles.my_applicationstop_description}>
            Review, track, and stay updated on your application status
          </p>
        </div>
        {/* <div className={styles.sort_by_item}>
          <p>Sort By :</p>
          <select
            value={sortValue}
            onChange={(e) => setSortValue(e.target.value)}
            name="sort-projects"
          >
            <option value="">Select Status</option>
            <option value="SELECTED">Shortlisted</option>
            <option value="PENDING">Pending</option>
          </select>
        </div> */}
        <div className={styles.my_applications_sort_by}>
          <section className={styles.my_applications_search_input}>
            <input
              value={searchApplication}
              onChange={(e) => setSearchApplication(e.target.value)}
              className={styles.my_applications_input_field}
              type="text"
              placeholder="Search application"
            />
            {searchApplication && (
              <div
                onClick={() => setSearchApplication("")}
                className={styles.my_applications_search_remove}
              >
                <CrossIconSVG />
              </div>
            )}
          </section>
          <CustomSortDropdown
            type="APPLICATION"
            value={selected}
            setValue={setSelected}
            options={sortOptions}
            defaultValue="Pending"
          />
        </div>
      </section>

      <section className={styles.my_applications_search_input}>
        <input
          value={searchApplication}
          onChange={(e) => setSearchApplication(e.target.value)}
          className={styles.my_applications_input_field}
          type="text"
          placeholder="Search application"
        />
        {searchApplication && (
          <div
            onClick={() => setSearchApplication("")}
            className={styles.my_applications_search_remove}
          >
            <CrossIconSVG />
          </div>
        )}
      </section>

      <section className={styles.my_applications_cards}>
        {isLoading ? (
          <div className={styles.loader_wrapper}>
            <ProjectCardSkeleton count={5} />
          </div>
        ) : myApplications?.length > 0 ? (
          <>
            {myApplications.map((application, id) => (
              <ProjectsCardComponent
                page={page}
                key={id}
                project={application}
              />
            ))}

            <InfiniteEndMessage message="No more applications" />
          </>
        ) : (
          <div className={styles.no_jobs}>
            <img
              src={noApplicationsImg}
              alt=""
              className={styles.noApplicationsImg}
            />
            <p className={styles.noApplications_text}>Oops! No data found</p>
          </div>
        )}
      </section>
    </section>
  );
};

export default MyApplicationsPage;
